import piiApi from '../../api/piiApi';

const actions = {
  async init({ commit }) {
    const customerPii = await piiApi.getCustomerPii();
    commit('setCustomerPii', { customerPii });
  },
};

const state = {
  customerPii: {},
};

const getters = {
};

const mutations = {
  // eslint-disable-next-line no-shadow
  setCustomerPii(state, { customerPii }) {
    state.customerPii = customerPii;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
